import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Button, Input } from "../../components";
import { DeleteAccount } from "../../utilities/api/auth/auth-service";
import { Form } from "react-bootstrap";

const VerifyDeleteAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState("false");

  let otpNo = location?.state?.otpNumber;

  useEffect(() => {
    document.body.classList.add("reset-page");
    return () => {
      document.body.classList.remove("reset-page");
    };
  }, []);

  const Deleteaccount = async () => {
    const result = await DeleteAccount({
      phone: location?.state?.phone,
      otpNumber: location?.state?.verifyBy === "otpNumber" ? Number(otp.join("")) : "",
      oldPassword: location?.state?.verifyBy === "password" ? Password : "",
      verifyBy: location?.state?.verifyBy
    });
    console.log(result, "Verified");
    if (result.status === 200) {
      toast.success(result.data.message)
      navigate("/", { state: { message: result.data.message } });
    } else {
      toast.error(result.response.data.message);
    }
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    if (location.state.verifyBy === "password") {
      if (/^\S+$/.test(Password)) {
        Deleteaccount()
      } else {
        toast.error("Password must not contain spaces");
      }
    } else {
      Deleteaccount()
    }

  };

  const handleChange = (element: any, index: number) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((ele, ind) => (ind === index ? element.value : ele))]);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  return (
    <>
      <div className="container">
        <div
          className="row justify-content-center align-items-center"
          style={{ height: "84vh" }}
        >
          <div className="col-md-5">
            <div className="position-relative">
              <div className="card">
                <div className="card-body">
                  <form>
                    <h3 className="card-title mb-3 text-start">
                      Delete Account
                    </h3>
                    {location?.state?.verifyBy === "otpNumber" &&
                      <>
                        <div className="mb-3 mt-1">
                          {" "}
                          <span className="fs-6 text-info">
                            {location.state.message}
                          </span>
                        </div>
                        {/* for testing otp show start */}
                        <span>
                          {otpNo}
                        </span>
                        {/* for testing otp show end */}
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              id="otp"
                              className="inputs d-flex flex-row justify-content-center mt-1"
                            >
                              {otp.map((item, index) => {
                                return (
                                  <Input
                                    autoFocus={index === 0 ? true : false}
                                    onChange={(e: any) => handleChange(e.target, index)}
                                    key={index + "resetotpinput"}
                                    onFocus={(e: any) => e.target.select()}
                                    value={item}
                                    maxLength="1"
                                    placeholder="-"
                                    name="otp"
                                    className="text-center form-control me-2 py-4"
                                    type="text"
                                    id={`${index}indexotp`} />
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    {location?.state?.verifyBy === "password" &&
                      <>
                        <div className="mb-3 text-start mt-4">
                          <label htmlFor="password" className="form-label">
                            Password <small className="text-danger">*</small>
                          </label>
                          <Input
                            onChange={(e: any) => setPassword(e.target.value)}
                            type={showPassword === "true" ? "text" : "password"}
                            placeholder="Enter Password"
                            id="resetpassword"
                            name="resetpasswordinput"
                            className="form-control" />
                        </div>
                        <div className="mb-3 text-start">
                          <Form.Check
                            onChange={(e: any) => setShowPassword(
                              showPassword === "false" ? "true" : "false"
                            )}
                            label="Show Password"
                            name="showPassword"
                            type="checkbox"
                            id="showPassword"
                            value={showPassword === "false" ? "true" : "false"}
                            checked={showPassword === "false" ? false : true} />
                        </div>
                      </>
                    }
                    <div className="row mt-3">
                      {/* <div className="col-md-6 text-start">
                        <NavLink to="/">Back to Login</NavLink>
                      </div> */}
                      <div className="col-md-12 text-end">
                        <Button
                          onClick={handleClick}
                          bname="Submit"
                          name="resetpassword"
                          id="resetpasswordinput"
                          className="btn btn-primary rounded-1"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export { VerifyDeleteAccount };
